export default "/assets/images/peacekeeper-4.png?c4836756d3108b6b2a839a0bb5f57bdd";